<!-- <div class="w_accountingprocessing__carousel">
    <div class="w_accountingprocessing-carousel__button-container w_accountingprocessing-carousel__button-container--left" ng-click="vm.previousVoucher()">
        <button class="w_accountingprocessing-carousel__button" ng-disabled="vm.isPreviousButtonDisabled()">
            <span class="w_accountingprocessing-carousel__icon fa-fw fas fa-chevron-left"></span>
        </button>
    </div>

    <div class="w_accountingprocessing-carousel__document" style="display: flex; flex-direction: column; position: relative">
        <div
            class="w-accountingprocessing__comment ng-scope"
            style="
                background: var(--tt-secondary-color);
                color: var(--tt-secondary-text-color);
                border: none;
                position: static;
                margin: 0;
                border-radius: 0;
                height: 2rem;
                padding: 0 0.8rem;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                gap: 2.8rem;
                transition: none;
            "
        >
            <button class="w-accountingprocessing__close" style="display: flex; align-items: center; gap: 0.4rem; position: static; opacity: 1" ng-click="vm.openVoucherPopup()">
                <span class="fa-fw far fa-external-link"></span>
                <span im-translate="open_in_popup"></span>
            </button>
            <div ng-if="vm.model.custact.show_comments_preview === '1'" style="display: contents">
                <button
                    ng-if="vm.model.custact.show_comments !== '0' && !vm.isCommentsOpen()"
                    class="w-accountingprocessing__close"
                    style="display: flex; align-items: center; gap: 0.4rem; position: static; opacity: 1"
                    ng-click="vm.toggleCommentsView('0')"
                >
                    <span class="fa-fw far fa-eye-slash"></span>
                    <span im-translate="hide_comments"></span>
                </button>
                <button
                    ng-if="vm.model.custact.show_comments === '0' || vm.isCommentsOpen()"
                    class="w-accountingprocessing__close"
                    style="display: flex; align-items: center; gap: 0.4rem; position: static; opacity: 1"
                    ng-click="vm.toggleCommentsView('1')"
                >
                    <span class="fa-fw far fa-eye"></span>
                    <span im-translate="show_comments"></span>
                </button>
            </div>
        </div>
        <ul
            ng-if="vm.model.custact.nbr_of_custactdialogs > '0' && vm.model.custact.acvoucherbunt_keyno === '0' && vm.model.custact.show_comments_preview === '1'"
            class="w-accountingprocessing__comments tt-scrollbar"
        >
            <li
                ng-repeat="event in vm.model.history"
                ng-if="vm.model.custact.show_comments !== '0'"
                class="w-accountingprocessing__comment"
                ng-class="event.open ? '' : 'w-accountingprocessing__comment--hidden'"
            >
                <span style="font-weight: 600">{{ event.heading }} {{ event.approved_by }}</span>
                <span style="font-size: 85%; opacity: 0.8">{{ event.approved_datetime }}</span>
                <span> - {{ event.messagetext }}</span>
            </li>
        </ul> -->

<ng-container *ngIf="!!params">
    <tt-document-viewer
        [ttModel]="params.custactDocument"
        tt-email-buttons="vm.model.emailButtons"
        ttEmailReplyView="inline"
        ttEmailUserSenderFallback="true"
        ttShowDocument="true"
    ></tt-document-viewer>
    <!-- tt-show-document="vm.carousel.showDocument" -->
</ng-container>
<!-- </div> -->
<!-- <email-view ng-if="vm.model.custactDocument.extension !== 'msg'" class="w_accountingprocessing-carousel__document" ></email-view> -->

<!-- <div class="w_accountingprocessing-carousel__button-container w_accountingprocessing-carousel__button-container--right" ng-click="vm.nextVoucher()">
        <button class="w_accountingprocessing-carousel__button" ng-disabled="vm.isNextButtonDisabled()">
            <span class="w_accountingprocessing-carousel__icon fa-fw fas fa-chevron-right"></span>
        </button>
    </div>
</div> -
</div> -->
